import { lazy } from "react"

const DemoPage$$__react__lazy__component = lazy(() => 
    import("./DemoPage__original__module.mjs")
        .then(module => module.get_$$DemoPage$$DemoPage$$react__component$$3optrozxvrgpv())
        .then(component => ({ default: component }))
)

export const get_$$DemoPage$$DemoPage$$react__component$$3optrozxvrgpv = () => DemoPage$$__react__lazy__component